import Vue from 'vue';
import Router from 'vue-router';
import Main from './views/Main.vue';
import SignUp from './views/SignUp.vue';
import Login from './views/Login.vue';
import Admin from './views/Admin.vue';
import ChartView from './views/Chart.vue';

Vue.use(Router);

// @ts-ignore
const router = new Router({
  routes: [
    {
      path: '/',
      name: 'main',
      component: Main,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/admin',
      name: 'admin',
      component: Admin,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/s/:squid',
      name: 'chart',
      component: ChartView,
    },
    {
      path: '/chart/:author/:meal/:size',
      name: 'chart',
      component: ChartView,
    },
    {
      path: '/chart/:author/:meal',
      name: 'chart2',
      component: ChartView,
    },
    {
      path: '/charts/:meals',
      name: 'charts',
      component: ChartView,
    },
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/About.vue'),
    },
    {
      path: '*',
      // @ts-ignore
      redirect: () => {
        window.location.href = 'https://fedfedfed.com';
      }
    }
  ],
});

router.beforeEach((to: {path: string, matched: {some: (f: any) => boolean}},
                   from: object, next: (path?: string) => void) => {
  const token = !!localStorage ? localStorage.getItem('token') : null;
  const requiresAuth = to.matched.some((record: {'meta': {requiresAuth: boolean}}) => record.meta.requiresAuth);
  const isLoginPage = to.matched.some((record: {'name': string}) => record.name === 'login');

  if (requiresAuth && !token) {
    window.location.href = 'https://fedfedfed.com';
    // next(`login?next=${to.path}`);
  } else if (!requiresAuth && token && isLoginPage) {
    next('/');
  } else {
    next();
  }
});

export default router;
